import { createFileRoute } from '@tanstack/react-router';

import { DmaRisksPage } from '@/features/esg/dma/components/DmaRisksPage';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId/risks')({
  component: DmaRisksRoute,
});

function DmaRisksRoute() {
  const { assessmentId } = Route.useParams();
  return <DmaRisksPage assessmentId={assessmentId} />;
}
